<template>
  <div class="page-content-wrapper">
    <div class="content">
      <div class="container-fluid container-fixed-lg">
        <div class="row p-3">
          <div class="col-lg-12">
            <h2 class="text-dag">{{ $t('profile_personal_email') }}</h2>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-6 m-b-10">
            <div class="card no-border widget-loader-circle no-padding rounded">
              <div class="card-body p-t-25 p-b-30">
                <form>
                  <div class="form-group contact">
                    <label for="email">
                      <p class="adviestitle">{{ $t('profile_set_email') }}:</p>
                    </label>
                    <b-form-input type="email"
                                  class="form-control form-control-lg"
                                  id="email"
                                  :placeholder="$t('profile_email')"
                                  v-model="changeData.Email">
                    </b-form-input>
                  </div>
                  <div class="form-check">
                    <b-form-checkbox type="checkbox"
                                     class="form-check-input"
                                     id="exampleCheck1"
                                     :disabled="changeData.Email==''"
                                     v-model="changeData.Confirm">
                    </b-form-checkbox>
                    <label for="exampleCheck1">
                      <p class="adviestitle-links">{{ $t('profile_set_email_confirm') }}</p>
                    </label>
                  </div>
                </form>
                <button class="advicebutton text-white confirm"
                        @click="submitChange">
                  {{ $t('profile_send') }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'

  export default {
    methods: {
      ...mapActions([
        'userChangeEmail',
      ]),
      submitChange () {
        if (this.changeData.Confirm) {
          this.userChangeEmail(this.changeData).then(response => {
            console.log(response)
          }, error => {
            console.error(error)
          })
        } else {
          console.error('Not confirmed')
        }
      }
    },
    data() {
      return {
        changeData: {
          Email: '',
          Confirm: false
        }
      }
    },
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/profile/ChangeEmail.vue